module.exports = require('../../es/symbol/iterator');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/symbol/iterator.js
// module id = 559
// module chunks = 0